import type * as Types from '../../../../graphql/base-types.graphql';

import { gql } from '@apollo/client';
import { CompanyFieldsFragmentDoc } from '../../../../graphql/gql-fragments/company.graphql';
import { IdentityFieldsFragmentDoc } from '../../../../graphql/gql-fragments/identity.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GqlFullReportTableQueryVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  date?: Types.InputMaybe<Types.Scalars['Date']['input']>;
}>;


export type GqlFullReportTableQuery = { company: { id: string, name: string, organizationNumber: string, email?: string | null, web?: string | null, useGravatar?: boolean | null, address?: any | null, currency: Types.GqlCurrency, foundationDate: string, bolagsverketsid?: string | null, county: string, municipal: string, isPublic: boolean, shareCapital: string, shareCapitalMax?: string | null, shareCapitalMin?: string | null, sharesTotal: string, sharesMax?: string | null, sharesMin?: string | null, sharesAtFoundation?: string | null, shareRegisterLimit?: number | null, authorizedSignatory: string, fiscalYear: Types.GqlFiscalYear, shareholderMeetingHowtoCall: string, residenceMunicipal: string, reservationArbitrator: boolean, reservationConsent: boolean, reservationDescrepancy: boolean, reservationMajority: boolean, reservationOther: string, reservationRightOfFirstRefusal: boolean, reservationPreferential: boolean, reservationReconciliation: boolean, reservationReconciliationDate?: string | null, reservationPostTransferPurchaseRight: boolean, reservationVote: boolean, reservationNoAuditor: boolean, boardMembersMin: string, boardMembersMax: string, boardSubstitutesMin: string, boardSubstitutesMax: string, stripeCustomerId?: string | null, stripeInvitePromoCode?: string | null, isAntlerCompany: boolean, allowShortQeso: boolean, hubspotObjectId?: string | null, capTableTrialExpires?: string | null, isDemo: boolean, createdAt: string, updatedAt: string, shareClasses: Array<{ name: string, voteWeight: string, quantity?: string | null }>, boardSettings?: { base: Types.GqlMeetingBase, frequency: number, dayOfWeek: Types.GqlDayOfWeek } | null }, fullShareReg: Array<{ strike: boolean, address: string, comment?: string | null, blockEnd: string, blockName: string, blockStart: string, hasGuardian: boolean, numberOfShares: number, shareClassName: string, registrationDate: string, fullyTransferred: boolean, hasShareCertificate: boolean, note: { primaryLang: string, secondaryLang: string }, shareholderIdentity: { id: string, identityNumberKind: number, identityNumber: string, juridicalKind: number, name: string, email?: string | null, emailMd5?: string | null, phone?: string | null, countryCode?: string | null, address?: string | null, userId?: string | null, isSwedish: boolean, createdAt: string, updatedAt: string, companyId: string } }> };

export type GqlDocGenFullShareRegQueryVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  date?: Types.InputMaybe<Types.Scalars['Date']['input']>;
  docLanguage: Types.GqlFileLanguageInput;
}>;


export type GqlDocGenFullShareRegQuery = { docGenFullShareReg: { docGen: any } };


export const FullReportTableDocument = gql`
    query FullReportTable($companyId: ID!, $date: Date) {
  company(id: $companyId) {
    ...CompanyFields
  }
  fullShareReg(companyId: $companyId, date: $date) {
    note {
      primaryLang
      secondaryLang
    }
    strike
    address
    comment
    blockEnd
    blockName
    blockStart
    hasGuardian
    numberOfShares
    shareClassName
    registrationDate
    fullyTransferred
    shareholderIdentity {
      ...IdentityFields
    }
    hasShareCertificate
  }
}
    ${CompanyFieldsFragmentDoc}
${IdentityFieldsFragmentDoc}`;

/**
 * __useFullReportTableQuery__
 *
 * To run a query within a React component, call `useFullReportTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useFullReportTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFullReportTableQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useFullReportTableQuery(baseOptions: Apollo.QueryHookOptions<GqlFullReportTableQuery, GqlFullReportTableQueryVariables> & ({ variables: GqlFullReportTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlFullReportTableQuery, GqlFullReportTableQueryVariables>(FullReportTableDocument, options);
      }
export function useFullReportTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlFullReportTableQuery, GqlFullReportTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlFullReportTableQuery, GqlFullReportTableQueryVariables>(FullReportTableDocument, options);
        }
export function useFullReportTableSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GqlFullReportTableQuery, GqlFullReportTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GqlFullReportTableQuery, GqlFullReportTableQueryVariables>(FullReportTableDocument, options);
        }
export type FullReportTableQueryHookResult = ReturnType<typeof useFullReportTableQuery>;
export type FullReportTableLazyQueryHookResult = ReturnType<typeof useFullReportTableLazyQuery>;
export type FullReportTableSuspenseQueryHookResult = ReturnType<typeof useFullReportTableSuspenseQuery>;
export type FullReportTableQueryResult = Apollo.QueryResult<GqlFullReportTableQuery, GqlFullReportTableQueryVariables>;
export const DocGenFullShareRegDocument = gql`
    query DocGenFullShareReg($companyId: ID!, $date: Date, $docLanguage: FileLanguageInput!) {
  docGenFullShareReg(
    companyId: $companyId
    date: $date
    docLanguage: $docLanguage
  ) {
    docGen
  }
}
    `;

/**
 * __useDocGenFullShareRegQuery__
 *
 * To run a query within a React component, call `useDocGenFullShareRegQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocGenFullShareRegQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocGenFullShareRegQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      date: // value for 'date'
 *      docLanguage: // value for 'docLanguage'
 *   },
 * });
 */
export function useDocGenFullShareRegQuery(baseOptions: Apollo.QueryHookOptions<GqlDocGenFullShareRegQuery, GqlDocGenFullShareRegQueryVariables> & ({ variables: GqlDocGenFullShareRegQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlDocGenFullShareRegQuery, GqlDocGenFullShareRegQueryVariables>(DocGenFullShareRegDocument, options);
      }
export function useDocGenFullShareRegLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlDocGenFullShareRegQuery, GqlDocGenFullShareRegQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlDocGenFullShareRegQuery, GqlDocGenFullShareRegQueryVariables>(DocGenFullShareRegDocument, options);
        }
export function useDocGenFullShareRegSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GqlDocGenFullShareRegQuery, GqlDocGenFullShareRegQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GqlDocGenFullShareRegQuery, GqlDocGenFullShareRegQueryVariables>(DocGenFullShareRegDocument, options);
        }
export type DocGenFullShareRegQueryHookResult = ReturnType<typeof useDocGenFullShareRegQuery>;
export type DocGenFullShareRegLazyQueryHookResult = ReturnType<typeof useDocGenFullShareRegLazyQuery>;
export type DocGenFullShareRegSuspenseQueryHookResult = ReturnType<typeof useDocGenFullShareRegSuspenseQuery>;
export type DocGenFullShareRegQueryResult = Apollo.QueryResult<GqlDocGenFullShareRegQuery, GqlDocGenFullShareRegQueryVariables>;